export default __webpack_public_path__ + "static/media/roadmap1.4ea6bb92.png";